<template>
  <div>
    <template v-if="header.id === 'checkbox'">
      <vchecklabel class="vchecklabel-block"
        :disabled="isLastAdmin || isUserAdmin"
        v-model="isSelected"/>
    </template>

    <template v-else-if="header.id === 'avatar'">
      <div class="column-user" @click="$emit('clicked')">
        <div>{{ !is_japan_locale ? user.full_name : user.full_name_reverse }}</div>
      </div>
    </template>

    <template v-else-if="header.id === 'rights'">
      <multiselect
        class="boxy big"
        v-model="userRole"
        :options="roles"
        :show-labels="false"
        :allow-empty="false"
        :searchable="true"
        :disabled="isLastAdmin || isUserAdmin"
        track-by="id"
        label="name"
      />
    </template>

    <template v-else-if="header.id === 'email'">
      <div>{{ user.email }}</div>
    </template>

    <template v-else-if="header.id === 'phone'">
      <div class="td-phone">{{ user.phone }}</div>
    </template>

    <template v-else-if="header.id === 'region'">
      <div class="company-region" :title="user.geo ? user.geo.description : ''">{{ user.geo ? user.geo.description : '' }}</div>
    </template>
  </div>
</template>

<script>
import Moment from 'moment'
import { ADMIN_ROLES, ROLE_COMPANY_ADMIN } from '@/_helpers/constants.js'

export default {
  name: 'preferences-accesses-row',

  props: {
    model: Object,
    currentUser: Object,
    header: Object,
    cell: Object,
  },

  computed: {
    user () {
      return this.model
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    isUserAdmin () {
      if (!this.model || !this.userRole || !this.currentUser) {
        return false
      }

      if (ADMIN_ROLES.includes(this.userRole.role) || this.userRole.role === ROLE_COMPANY_ADMIN) {
        return this.model.email === this.currentUser.email
      } else {
        return false
      }
    },

    isLastAdmin () {
      if (!this.user) {
        return false
      }

      return this.user.isLastAdmin
    },

    roles () {
      return this.$store.getters['dictionary/userRoles']
    },

    userRole: {
      get () {
        return this.model.roles[0] || {}
      },

      set (val) {
        this.$store
          .dispatch('users/updateUsers', [{...this.user, roles: [val]}])
      }
    },

    createdAt () {
      return this.model.created_at
        ? Moment(this.model.created_at).format('DD.MM')
        : null
    },

    isSelected: {
      get () {
        return this.$store.getters['users/isSelected'](this.model)
      },

      set (state) {
        this.$store.dispatch('users/setSelectedState', {model: this.model, state})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.column-name {
  color: $green;
  cursor: pointer;
}

.column-user {
  cursor: pointer;
  display: flex;
  align-items: center;

  img {
    min-width: 36px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 4px;
  }
}

.column-date {
  color: $grey-color;
}

.company-row {
  font-size: 15px;
  line-height: 24px;
  height: auto;
  border-bottom: 1px solid #d1d8e0;

  &:first-child {
    border-top: 1px solid #d1d8e0;
  }

  td {
    padding: 4px 8px;
  }
}

.company-region {
  display: inline-block;
  vertical-align: top;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90px;
}
.td-phone {
  white-space: nowrap;
}
</style>
